import useRouter from 'use-react-router';

const useProjectId = () => {
  const { projectId } = useRouter().match.params;

  return projectId;
};

export default useProjectId;
